import crel from 'crel';
import isEqual from 'lodash-es/isEqual';
import './tooltip.css';
import L10n from '../../l10n/index.js';
import CircleButton from './circle_button';
import Plugin from '../../core/plugin';
import { maxIndex, readingTime } from '../../helpers';
import * as actionCreator from '../../store/actions';
import ToggleButton from './toggle_button';
export default class Toolbar extends Plugin {
    constructor() {
        super();
        this.html = null;
        this.drawer = null;
        this.brand = null;
        this.levelButtons = [];
        this.visibilityButton = null;
        this.readingTime = [];
        this.drawer = crel('div', {
            'kjuicer-controller-drawer': true,
        });
        this.brand = crel('div', { 'kjuicer-controller-brand': true }, crel('a', { href: 'https://tour.kjuicer.com' }, L10n.gettext('powered_by')));
        this.html = crel('div', {
            'kjuicer-controller-bar': true,
        }, this.drawer, this.brand);
    }
    static emptyHl() {
        return { hlColor: '#fff' };
    }
    init(view, appState, dispatch) {
        this.evalReadingTime(view, appState.highlighters);
        if (!appState.isSelfContained) {
            this.html.style.zIndex = (maxIndex() + 1).toString();
        }
        this.visibilityButton = new ToggleButton(appState.visibility, () => dispatch(actionCreator.toggleVisibility()), appState.help);
        this.levelButtons = this.generateCircles(appState, dispatch, this.readingTime);
        this.levelButtons.map((levelButton, i) => levelButton.toggleActive(appState.level === i));
        if (!appState.brand) {
            this.brand.style.display = 'none';
        }
        this.visibilityButton.init(this.drawer);
        this.levelButtons.map((levelButton) => levelButton.init(this.drawer));
        view.appendChild(this.html);
    }
    update(view, appState, dispatch) {
        /* Adjust Visibility button */
        if (appState.visibility !== appState.prev.visibility) {
            this.visibilityButton.update(appState.visibility);
        }
        /* Update only if highlighters are changed */
        if (!isEqual(appState.highlighters, appState.prev.highlighters)) {
            const nextButtons = this.generateCircles(appState, dispatch, this.readingTime);
            this.levelButtons.map((levelButton) => levelButton.destroy());
            nextButtons.map((levelButton) => levelButton.init(this.drawer));
            this.levelButtons = nextButtons;
            this.levelButtons.map((levelButton, i) => levelButton.toggleActive(appState.level === i));
        }
        /* Adjust Active button */
        if (appState.level !== appState.prev.level) {
            this.levelButtons.map((levelButton, i) => levelButton.toggleActive(appState.level === i));
        }
        if (appState.help && appState.html !== appState.prev.html) {
            this.evalReadingTime(view, appState.highlighters);
            this.levelButtons.map((levelButton, i) => levelButton.updateTooltip(this.readingTime[i]));
        }
    }
    generateCircles(appState, dispatch, minutesArray) {
        const circles = appState.highlighters
            .map((hl, i) => new CircleButton(i + 1, [{ name: 'click', action: () => dispatch(actionCreator.goToLevel(i + 1)) }], hl, minutesArray[i + 1], appState.help));
        /* include level 0 */
        circles.unshift(new CircleButton(0, [{ name: 'click', action: () => dispatch(actionCreator.goToLevel(0)) }], Toolbar.emptyHl(), minutesArray[0], appState.help));
        return circles;
    }
    evalReadingTime(view, highlighters) {
        this.readingTime = highlighters.map((hl, i) => readingTime(view, i + 1));
        this.readingTime.unshift(readingTime(view, 0));
    }
}
